import type { AggregatorAdministrator, TranslationFunction } from "./types";

export const getAdministratorFullName = (administrator?: AggregatorAdministrator) =>
  administrator?.person?.full_name || "-";

export const getAdministratorAccountTypeLabel = (
  accountType: string | undefined,
  t: TranslationFunction
) => {
  switch (accountType) {
    case "mastercard_foundation_admin":
      return t("aggregatorDetails.administratorModal.mcfAdmin") || "MCF";
    case "aggregator_admin":
    default:
      return t("aggregatorDetails.administratorModal.aggregatorAdmin") || "Aggregator";
  }
};
